/* v19.2: reviews strip stays still; shoppers swipe or drag it themselves */
(function(){
  if(!document.querySelector('.tc-rvw'))return;
  var tries=0;
  function hold(){
    var w=document.querySelector('.tc-rvw.is-live');
    if(!w){if(++tries<60)setTimeout(hold,500);return}
    if(w.getAttribute('data-lx-hold'))return;
    w.setAttribute('data-lx-hold','1');
    w.addEventListener('mouseleave',function(e){e.stopImmediatePropagation()},true);
    w.dispatchEvent(new MouseEvent('mouseenter'));
  }
  hold();
})();
/* v19.2: move the phone sticky buy bar to the page body so it pins to the bottom of the screen */
(function(){
  var st=document.querySelector('.tc-sticky');if(!st||st.getAttribute('data-moved'))return;
  var host=st.closest('.tc'),w=document.createElement('div');
  w.className='tc tc-sticky-host';w.setAttribute('style',host?(host.getAttribute('style')||''):'');
  st.setAttribute('data-moved','1');w.appendChild(st);document.body.appendChild(w);
})();
/* v19.6: size guide + Find my size live right inside the "What size should I get?" answer (hoodie + socks + tees) */
(function(){
  var d=document,m=d.getElementById('tc-sg')||d.getElementById('tc-sockg');if(!m)return;
  var body=m.querySelector('.tc-body');if(!body||!body.children.length)return;
  var dt=null;[].forEach.call(d.querySelectorAll('.tc-faq details'),function(x){var s=x.querySelector('summary');if(!dt&&s&&/size/i.test(s.textContent))dt=x});
  if(!dt){var fq=d.querySelector('.tc-faq');if(!fq)return;dt=d.createElement('details');var sm=d.createElement('summary');sm.textContent='What size should I get?';dt.appendChild(sm);var first=fq.querySelector('details');if(first)fq.insertBefore(dt,first);else fq.appendChild(dt)}
  [].forEach.call(dt.querySelectorAll('button.tc-link'),function(b){b.parentNode.removeChild(b)});
  var sock=m.id==='tc-sockg',ans=dt.querySelector('p');
  var box=d.createElement('div');box.className='lx-sgin';
  while(body.firstChild)box.appendChild(body.firstChild);
  if(ans&&box.querySelector('.tc-fs'))ans.hidden=true;
  try{var bg=getComputedStyle(dt.closest('.tc')).backgroundColor.match(/\d+(\.\d+)?/g);if(bg&&(0.299*bg[0]+0.587*bg[1]+0.114*bg[2])<110)box.classList.add('lx-sg-dark')}catch(e){}
  dt.appendChild(box);dt.id='lx-size';
  /* v20: the size link opens the guide in a popup again; when it closes, the guide goes back into the FAQ answer */
  var mb=m.querySelector('.tc-body'),prevOv='';
  function closePop(){if(m.hidden&&box.parentNode===dt)return;m.hidden=true;d.body.style.overflow=prevOv;if(box.parentNode!==dt)dt.appendChild(box)}
  function go(e){
    e.preventDefault();e.stopPropagation();
    [].forEach.call(d.querySelectorAll('.tc-modal'),function(x){if(x!==m)x.hidden=true});
    mb.appendChild(box);prevOv=d.body.style.overflow;m.hidden=false;d.body.style.overflow='hidden';
    var sh=m.querySelector('.tc-sheet');if(sh)sh.scrollTop=0;
    var x=m.querySelector('.tc-x');if(x)setTimeout(function(){x.focus()},30);
  }
  m.addEventListener('click',function(e){if(e.target===m||(e.target.closest&&e.target.closest('.tc-x,[data-close],[data-sg-close]'))){e.preventDefault();closePop()}});
  d.addEventListener('keydown',function(e){if(e.key==='Escape'&&!m.hidden)closePop()});
  new MutationObserver(function(){if(m.hidden&&box.parentNode!==dt){d.body.style.overflow=prevOv;dt.appendChild(box)}}).observe(m,{attributes:true,attributeFilter:['hidden']});
  d.addEventListener('click',function(e){
    var t=e.target;if(!t||!t.closest)return;
    if(t.closest('[data-tc-sg]')||(sock&&t.closest('.tc-sl .tc-link')))go(e);
  },true);
})();
/* v19.1: never offer the product you're already looking at as an add-on */
(function(){
  var root=document.querySelector('[data-tc-buy]');if(!root)return;
  var ids={};ids[root.getAttribute('data-variant')]=1;
  [].forEach.call(root.querySelectorAll('.tc-size[data-id]'),function(b){ids[b.getAttribute('data-id')]=1});
  [].forEach.call(document.querySelectorAll('#tc-up .tc-row[data-id]'),function(r){if(ids[r.getAttribute('data-id')])r.parentNode.removeChild(r)});
})();
/* v19.3: review headlines ("Fantastic", "Highly recommended") as small sage-green labels so they don't clash with the gold stars */
(function(){
  var r=document.querySelector('[id^="tcr-"]');if(!r)return;
  var s=document.createElement('style');
  s.textContent='#'+r.id+' .fera-review-heading,#'+r.id+' .fera-review-heading *{color:#9fc3a8!important;font-family:var(--lx-sans)!important;font-size:12px!important;font-weight:700!important;letter-spacing:.12em!important;text-transform:uppercase!important}#'+r.id+' .fera-review-heading{margin:0 0 2px!important}';
  document.body.appendChild(s);
})();
/* v19.10: links to /products/take-care#reviews land on the reviews */
(function(){
  if(location.hash!=='#reviews')return;
  var tries=0;(function go(){var r=document.querySelector('[id^="tcr-"]')||document.querySelector('.tc-rvw');if(!r){if(++tries<20)setTimeout(go,250);return}
    var y=r.getBoundingClientRect().top+window.pageYOffset-70;window.scrollTo({top:y,behavior:'smooth'})})();
})();
